import regeneratorRuntime from "regenerator-runtime";
import Dashboardjs from './dashboard';
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class Guarantorjs {
    constructor() {
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
        this.dashboardjs = new Dashboardjs;
    }

    async addGuarantor(e, submittingLabelId, successLabelId, failedValidateId, sectionId, completedElementId, iconClass, successIconUrl) {
        e.preventDefault();
        var that = this;
        let button = this.utilsjs.disableButton(e);

        that.utilsjs.showById(submittingLabelId);
        that.utilsjs.hideById(failedValidateId);

        if (await that.ajaxjs.serializeAndPostForm(e.target.id, 'AddGuarantor', 'Member') === '201') {
            that.utilsjs.hideById(submittingLabelId);
            that.utilsjs.hideById(failedValidateId);
            that.utilsjs.showById(successLabelId);
            that.utilsjs.hideById(sectionId);
            //that.utilsjs.changeInnerHtmlById(completedElementId, 'Completed');

            $(`.${iconClass}`).attr('src', successIconUrl);
            $(`.${iconClass}`).removeClass('required-icon');
            $(`.${iconClass}`).addClass('complete-icon');
            $('#ItemsRequire').text($('.required-icon').length);

            $(".guarantor-incomplete").hide();
            $(".guarantor-complete").show();
            $(".guard-section .guarantor-msg-block").removeClass("display-none");
            $(".guard-section .guarantor-form-block").addClass("display-none");
            $(".guard-section").addClass("section-success");

            //CUSTOM: check show Declaration
            cscpjs.default.dashboardjs.declarationCheckShow.Guarantor = true;
            cscpjs.default.dashboardjs.declarationShowModule();

            that.dashboardjs.checkIfCycleIsComplete();
            window.scrollTo(0, 200);
        } else {
            that.utilsjs.hideById(submittingLabelId);
            that.utilsjs.hideById(successLabelId);
            that.utilsjs.showById(failedValidateId);
            button.disabled = false;

            //CUSTOM: check show Declaration
            that.dashboardjs.declarationCheckShow.Guarantor = false;
            that.dashboardjs.declarationShowModule();
        }
    }


}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/guarantor.js